// extracted by mini-css-extract-plugin
export default {"linkContainer":"ModelLegalTerms-module__linkContainer__y65QnfD"};